module.exports = __webpack_public_path__ + "static/media/599.767(21).dcd98f84.pdf";